import DEFAULT from '@/config/premadeConfigs'
import { premadeStepsWithoutFamily } from '@/config/premadeConfigs/steps'
import { PartnerConfig } from '@/types'

const { LOGOS, APPNAMES, FIELDS } = DEFAULT

const bupa: PartnerConfig = {
  branding: {
    logo: [
      LOGOS.BABYLON,
      {
        src: '/images/GBR/bupa.png',
        alt: 'Bupa logo',
      },
    ],
  },
  config: {
    id: 'bupa',
    name: 'Bupa',
    appName: APPNAMES.BABYLON,
    acceptLanguage: 'en-GB',
    codes: {
      membership: '',
    },
    partnerUrlSlug: 'bupa',
    steps: premadeStepsWithoutFamily,
    fields: [
      [FIELDS.EMAIL],
      [
        FIELDS.FIRST_NAME,
        FIELDS.LAST_NAME,
        FIELDS.DATE_OF_BIRTH,
        FIELDS.PASSWORD,
        FIELDS.PHONE_COUNTRY_CODE,
        FIELDS.PHONE_NUMBER,
      ],
    ],
  },
  content: {
    'en-GB': {
      steps: [
        {
          title: 'Register for Digital GP in partnership with Babylon',
          stepperLabel: 'Welcome',
          copy: [
            'Imagine if seeing a GP was as easy as checking your bank balance. With Digital GP in partnership with Babylon, it is. The app gives you 24/7 unlimited access to GPs with a simple tap of your phone.',
            'Enter your email address to get started.',
          ],
          productFeatures: [
            {
              icon: 'ChatFilled',
              title: 'Check your symptoms quickly and easily',
              description:
                'Check your symptoms instantly to get the most appropriate health information and next steps.',
            },
            {
              icon: 'PeopleMedicalSpecialist',
              title: 'Talk to a doctor, 24/7',
              description:
                'Talk to a doctor at any time of the day or night, directly from your mobile. Appointments are normally available within two hours.',
            },
            {
              icon: 'Medication',
              title: 'Prescriptions sent to a local pharmacy of your choice',
              description:
                'Have a prescription sent electronically to your chosen pharmacy for collection*, or get it delivered free to your home or workplace. *If abroad, available only in specific locations, and subject to the availability of the pharmacy.',
            },
          ],
        },
        {
          title: 'Details',
          stepperLabel: 'Registration',
          copy: [
            'We just need a few more details to complete your Digital GP registration. ',
            'Make sure that the name that you register with matches the details on your Bupa PMI policy. This will ensure that your registration matches with the eligibility details provided by Bupa.',
            'Find out how to enter your Digital GP membership code on the next screen',
          ],
        },
        {
          title: 'You’re nearly there',
          stepperLabel: 'Thank You',
          copy: [
            'Click below to enter your Digital GP membership code then you’ll be all set to book an appointment.',
            'You can find your membership code on your Bupa PMI policy documents.',
            'Book an appointment online and download the app to get started. You can login on the app using the details you have just created.',
          ],
          cta: {
            showDownloadButtons: true,
            label: 'Enter membership code',
            webAppPartialLink: '/account/0/membership/plans',
            type: 'ButtonLink',
          },
        },
      ],
      footerLinks: DEFAULT.FOOTERLINKS.GBR,
    },
  },
}

export default bupa
